import { useState } from "react";
import { Link } from "react-router-dom";

export default function CTASection() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [statusMsg, setStatusMsg] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus("loading");

    const form = e.currentTarget as HTMLFormElement;
    const honeypotValue = (form.querySelector('input[name="phone_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypotValue) {
      setStatus("success");
      setStatusMsg("订阅成功！感谢你的关注。");
      setEmail("");
      return;
    }

    try {
      const formData = new FormData(form);
      formData.delete("phone_alt");
      formData.append("email", email);

      const response = await fetch("https://readdy.ai/api/form/d9phjjdi2vhsdh2d34j0", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === "OK") {
        setStatus("success");
        setStatusMsg("订阅成功！感谢你的关注，赛事资讯将第一时间送达你的邮箱。");
        setEmail("");
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
        if (typeof serverMsg === "string" && serverMsg.includes("spam")) {
          setStatus("success");
          setStatusMsg("订阅成功！感谢你的关注。");
          setEmail("");
        } else {
          setStatus("error");
          setStatusMsg(typeof serverMsg === "string" ? serverMsg : "订阅失败，请稍后重试");
        }
      }
    } catch {
      setStatus("error");
      setStatusMsg("网络错误，请稍后重试");
    }
  };

  return (
    <section className="relative py-20 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20orange%20amber%20gradient%20abstract%20background%20with%20soft%20glowing%20light%20rays%20radiating%20from%20center%20subtle%20geometric%20pattern%20energetic%20atmosphere%20modern%20esports%20arena%20vibe&width=1800&height=600&seq=cta-bg-home&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-background-950/90 to-background-950/70"></div>

      <div className="relative max-w-[1280px] mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-4">
          准备好开始你的竞技之旅了吗？
        </h2>
        <p className="text-background-50/70 max-w-lg mx-auto mb-8 text-sm md:text-base leading-relaxed">
          每天新赛事，每天新挑战。加入500万+玩家的行列，与万千竞技者同台较量，赢取属于你的荣耀和奖励！
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
          <Link
            to="/category/jingji-saishi"
            className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 transition-all whitespace-nowrap"
          >
            立即参赛
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 rounded-full border-2 border-background-50/30 text-background-50 text-base font-semibold hover:bg-background-50/10 transition-all whitespace-nowrap"
          >
            关于我们
          </Link>
        </div>

        <form onSubmit={handleSubmit} className="max-w-md mx-auto" data-readdy-form="">
          <p className="text-sm text-background-50/60 mb-3">订阅赛事资讯，不错过任何精彩</p>
          <div className="flex flex-col sm:flex-row gap-3">
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="输入你的邮箱地址"
              required
              className="flex-1 px-5 py-3 rounded-full bg-background-50/10 border border-background-50/20 text-background-50 placeholder:text-background-50/40 text-sm outline-none focus:border-accent-400/50 transition-colors"
            />
            <button
              type="submit"
              disabled={status === "loading"}
              className="px-6 py-3 rounded-full bg-accent-500 text-background-950 text-sm font-semibold hover:bg-accent-400 transition-colors whitespace-nowrap disabled:opacity-60"
            >
              {status === "loading" ? "订阅中..." : "订阅"}
            </button>
          </div>
          <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="hidden-honeypot" />
          {status !== "idle" && (
            <p className={`mt-3 text-sm ${status === "success" ? "text-accent-300" : "text-red-400"}`}>
              {statusMsg}
            </p>
          )}
        </form>
      </div>
    </section>
  );
}